import { SxProps } from "@mui/material"
import { Theme } from "@mui/system"

export const card: SxProps<Theme> = {
  display: "grid",
  gridAutoFlow: "row",
  backgroundColor: "var(--Schemes-Surface)",
  fontFamily: "Roboto, sans-serif",
  color: "var(--secondary-text)",
  padding: "8px 8px 16px 8px",
  gap: "8px",
  borderRadius: "16px",
  border: "1px solid var(--Schemes-Outline-Variant)",
  boxShadow: "0px 2px 4px 0px #00000014",
  gridTemplate: "auto minmax(36px, auto) 1fr / 1fr",
  boxSizing: "border-box",
  overflowX: "hidden",
}

export const cardImg: SxProps<Theme> = {
  position: "relative",
  padding: "0px 0px 51% 0px",
  borderRadius: "8px",
  backgroundColor: "var(--Schemes-Surface-Container-Highest)",
  img: {
    position: "absolute",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
}

export const cardContent: SxProps<Theme> = {
  padding: 0,
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  paddingBottom: "8px",
}
